/* ====================================================================
   COMPETITION PRESETS — one-click setups for common NZ bowls formats

   To add a new format, add an entry to PRESETS — no other changes needed.
   ==================================================================== */
export const PRESETS = [
  {
    key: 'champ-singles', label: 'Championship Singles', icon: 'fa-user',
    desc: 'First to 21, 4 bowls, NZ interclub standard',
    settings: { format: 'singles', playersPerTeam: 1, bowlsPerPlayer: 4, matchType: 'first-to', targetScore: 21, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'champ-pairs', label: 'Championship Pairs', icon: 'fa-users',
    desc: '18 ends, 4 bowls each, 2 players per team',
    settings: { format: 'pairs', playersPerTeam: 2, bowlsPerPlayer: 4, matchType: 'ends', numberOfEnds: 18, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'champ-triples', label: 'Championship Triples', icon: 'fa-users',
    desc: '18 ends, 3 bowls each, 3 players per team',
    settings: { format: 'triples', playersPerTeam: 3, bowlsPerPlayer: 3, matchType: 'ends', numberOfEnds: 18, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'champ-fours', label: 'Championship Fours', icon: 'fa-users',
    desc: '18 ends, 2 bowls each, 4 players per team',
    settings: { format: 'fours', playersPerTeam: 4, bowlsPerPlayer: 2, matchType: 'ends', numberOfEnds: 18, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'twilight-social', label: 'Twilight / Social Bowls', icon: 'fa-sun-o',
    desc: 'Triples sets play with twilight scoring and extra-end set tie decider',
    settings: {
      format: 'triples', playersPerTeam: 3, bowlsPerPlayer: 2,
      matchType: 'sets', endsPerSet: 5, numberOfSets: 2,
      numberOfRounds: 6, numberOfSections: 1,
      drawMethod: 'random', teamAssignment: 'manual',
      rinks: 8,
      scoringMethod: 'twilight',
      winPoints: 3, drawPoints: 2, lossPoints: 1, byePoints: 15,
      pointsPerSetWon: 3, pointsPerEndWon: 1,
      extraEndOnDraw: true,
      includeInClubLeaderboard: true,
      tournamentType: 'round-robin',
    },
  },
  {
    key: '242-pairs', label: '2-4-2 Pairs', icon: 'fa-exchange',
    desc: '2 bowls, 4 bowls, 2 bowls per end, 10 ends',
    settings: { format: '2-4-2-pairs', playersPerTeam: 2, bowlsPerPlayer: 4, matchType: 'ends', numberOfEnds: 10, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'social-pairs', label: 'Social/Jackpot Pairs', icon: 'fa-clock-o',
    desc: 'Timed 75 min, relaxed play, pairs format',
    settings: { format: 'pairs', playersPerTeam: 2, bowlsPerPlayer: 4, matchType: 'timed', timeLimit: 75, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'jackpot-auto', label: 'Random Draw Teams', icon: 'fa-random',
    desc: 'Players register individually, teams randomly generated',
    settings: { format: 'pairs', playersPerTeam: 2, bowlsPerPlayer: 4, matchType: 'timed', timeLimit: 35, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin', teamAssignment: 'auto-random' },
  },
  {
    key: 'social-triples', label: 'Social Triples', icon: 'fa-clock-o',
    desc: '10 ends, 3 bowls each, friendly play',
    settings: { format: 'triples', playersPerTeam: 3, bowlsPerPlayer: 3, matchType: 'ends', numberOfEnds: 10, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'first-to-singles', label: 'First to 21 Singles', icon: 'fa-bullseye',
    desc: 'Play until someone reaches 21 shots',
    settings: { format: 'singles', playersPerTeam: 1, bowlsPerPlayer: 4, matchType: 'first-to', targetScore: 21, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'sets-pairs', label: 'Sets Play Pairs', icon: 'fa-th',
    desc: '3 sets of 9 ends, best-of-3 format',
    settings: { format: 'pairs', playersPerTeam: 2, bowlsPerPlayer: 4, matchType: 'sets', endsPerSet: 9, numberOfSets: 3, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'round-robin' },
  },
  {
    key: 'knockout-singles', label: 'Knockout Singles', icon: 'fa-sitemap',
    desc: 'Single elimination, 18 ends per match',
    settings: { format: 'singles', playersPerTeam: 1, bowlsPerPlayer: 4, matchType: 'ends', numberOfEnds: 18, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'knockout' },
  },
  {
    key: 'knockout-pairs', label: 'Knockout Pairs', icon: 'fa-sitemap',
    desc: 'Single elimination pairs, 18 ends per match',
    settings: { format: 'pairs', playersPerTeam: 2, bowlsPerPlayer: 4, matchType: 'ends', numberOfEnds: 18, rinks: 8, winPoints: 3, drawPoints: 1, lossPoints: 0, byePoints: 0, tournamentType: 'knockout' },
  },
  {
    key: 'custom', label: 'Custom Competition', icon: 'fa-cog',
    desc: 'Full control over all settings',
    settings: null,
  },
];

export const DEFAULT_RULES_BANK = {
  jackDelivery: 'roll',
  deadEndPolicy: 'replay',
  jackOutPolicy: 'dead-end',
  customRulesNote: '',
};

export const DEFAULT_GENERIC_RULES = [
  { id: 'wb-jack-delivery', title: 'Jack Delivery', detail: 'The jack is delivered by rolling from the mat.', source: 'site' },
  { id: 'wb-jack-valid-length', title: 'Minimum Jack Length', detail: 'A delivered jack must reach the required minimum length to be live.', source: 'site' },
  { id: 'wb-jack-out-policy', title: 'Jack Out Of Bounds', detail: 'If the jack leaves play, the end is treated as a dead end unless local regulations override.', source: 'site' },
  { id: 'wb-dead-end-procedure', title: 'Dead End Procedure', detail: 'Dead ends are replayed from the same end and count of play.', source: 'site' },
  { id: 'wb-foot-fault', title: 'Mat / Foot Fault', detail: 'At delivery, at least one foot must be on or above the mat and within boundary limits.', source: 'site' },
  { id: 'wb-touchers', title: 'Toucher Marking', detail: 'A bowl that first touches the jack in its original course is marked as a toucher.', source: 'site' },
  { id: 'wb-measuring', title: 'Measuring Shots', detail: 'Close heads are measured before deciding shot count.', source: 'site' },
  { id: 'wb-score-entry', title: 'Score Verification', detail: 'Both sides confirm the result before cards are submitted.', source: 'site' },
];

export const DEFAULT_FORM = {
  name: '', format: 'singles', playersPerTeam: 1, bowlsPerPlayer: 4, matchType: 'ends', numberOfEnds: 18,
  targetScore: 21, timeLimit: 75, endsPerSet: 9, numberOfSets: 3,
  rinks: 8, numberOfSections: 1, entryFee: 0, winPoints: 3, drawPoints: 1,
  lossPoints: 0, byePoints: 0, scoringMethod: 'standard', pointsPerSetWon: 0, pointsPerEndWon: 0,
  includeInClubLeaderboard: true,
  rulesBank: DEFAULT_RULES_BANK,
  appliedRules: [],
  extraEndOnDraw: false, tournamentType: 'round-robin', drawMethod: 'random', teamAssignment: 'manual',
  hasFinalsSeries: false, finalsFormat: 'semi-final', finalsEnds: null,
  quarterFinalEnds: null, semiFinalEnds: null, finalEnds: null,
  startDate: '', endDate: '', roundStartTimes: {}, selectedGreens: null, rinksPerGreen: null,
  finalsStartDates: {}, finalsStartTimes: {},
  allowedMembershipTypes: null,
};

/* ====================================================================
   WORKFLOW STEPS
   ==================================================================== */
export const STEPS = [
  { key: 'home', label: 'Home', icon: 'fa-home', desc: 'Competition overview' },
  { key: 'players', label: 'Players', icon: 'fa-users', desc: 'Register players' },
  { key: 'teams', label: 'Teams', icon: 'fa-group', desc: 'Create teams' },
  { key: 'fixtures', label: 'Draw', icon: 'fa-list', desc: 'Generate fixtures' },
  { key: 'scores', label: 'Scores', icon: 'fa-pencil', desc: 'Enter scores' },
  { key: 'leaderboard', label: 'Results', icon: 'fa-trophy', desc: 'View standings' },
];
